import React, { useEffect, useRef } from 'react';

import './landing.scss';
import { useAuth } from '../../context';
import {
    AdminNavbar,
    Navbar,
    AboutSection,
    ServicesSection,
    BlogSection,
    Header,
    Testimonials,
    Footer
} from '..';
import { Theme } from '../../config';

export const HomePage: React.FC = React.memo(() => {
    const { session } = useAuth();
    const topRef = useRef<HTMLElement>(null);
    const aboutRef = useRef<HTMLElement>(null);
    const serviceRef = useRef<HTMLElement>(null);
    const blogRef = useRef<HTMLElement>(null);
    const quoteRef = useRef<HTMLElement>(null);

    useEffect(() => {
        switch (window.location.hash) {
            case '#about':
                aboutRef.current?.scrollIntoView();
                break;
            case '#service':
                serviceRef.current?.scrollIntoView();
                break;
            case '#blog':
                blogRef.current?.scrollIntoView();
                break;
            case '#quote':
                quoteRef.current?.scrollIntoView();
                break;
            default:
                topRef.current?.scrollIntoView();
                break;
        }
    }, []);

    return (
        <section ref={topRef}>
            {session.MemberGuid ? <AdminNavbar landing /> : <Navbar landing />}
            <Header />
            <div className='landing' style={{ background: Theme.background }}>
                <div className='landing__container'>
                    <Testimonials />
                </div>
                <div className='landing__container'>
                    <AboutSection ref={aboutRef} />
                    <h1 className='landing__title'>Services</h1>
                    <ServicesSection ref={serviceRef} />
                    {/* <h1 className='landing__title'>Blogs</h1>
                    <BlogSection ref={blogRef} /> */}
                </div>
                <div className='landing__container'>
                    <section className='landing__quote' ref={quoteRef}>
                        <p className='quote-animation'>
                            "Compound Interest: The Eighth Wonder of the World.
                            <br /> He who understands it, earns it…
                            <br /> He who doesn’t, pays it…"
                            <br /> -Albert Einstein-
                        </p>
                    </section>
                </div>
            </div>
            <Footer />
        </section>
    );
});
